var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestionGreenPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-question-green-pen"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-question-green-pen",
    clipPath: "url(#clip-icon-question-green-pen)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    fill: "#2f0",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957",
    transform: "translate(-194 -458.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pen",
    "data-name": "Icon awesome-pen",
    d: "M5.844,1.875,8.417,4.448,2.829,10.036l-2.294.253A.482.482,0,0,1,0,9.756l.255-2.3L5.844,1.875Zm4.165-.383L8.8.283a.965.965,0,0,0-1.365,0L6.3,1.42,8.872,3.993l1.137-1.137a.965.965,0,0,0,0-1.365Z",
    transform: "translate(201.225 465.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-question",
    "data-name": "Icon awesome-question",
    d: "M4.583,0A3.057,3.057,0,0,0,1.868,1.436a.379.379,0,0,0,.082.519l.681.516a.379.379,0,0,0,.525-.065,1.531,1.531,0,0,1,1.306-.78c.485,0,1.086.312,1.086.783,0,.356-.294.539-.773.807-.559.313-1.3.7-1.3,1.679v.154a.379.379,0,0,0,.379.379H5a.379.379,0,0,0,.379-.379V4.958c0-.676,1.976-.7,1.976-2.534A2.711,2.711,0,0,0,4.583,0ZM4.425,5.892A1.093,1.093,0,1,0,5.518,6.985,1.094,1.094,0,0,0,4.425,5.892Z",
    transform: "translate(196.648 462.561)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionGreenPen);
export default __webpack_public_path__ + "static/media/icon-question-green-pen.06bd91b323383319484597583d026fa2.svg";
export { ForwardRef as ReactComponent };